import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/site/Home";
import Support from "@/pages/site/Support";
import Faq from "@/pages/site/Faq";
import LegalPage from "@/pages/site/LegalPage";
import SafetyPage from "@/pages/site/SafetyPage";
import HowItWorks from "@/pages/site/HowItWorks";
import Plans from "@/pages/site/Plans";
import NotFound from "@/pages/site/NotFound";
import { AuthProvider } from "@/admin/AuthContext";
import RequireAdmin from "@/admin/RequireAdmin";
import AdminShell, { AdminHome } from "@/admin/AdminShell";
import AdminLogin from "@/admin/pages/Login";
import Users from "@/admin/pages/Users";
import UserDetail from "@/admin/pages/UserDetail";
import Reviews from "@/admin/pages/Reviews";
import Launch from "@/admin/pages/Launch";
import Promotions from "@/admin/pages/Promotions";
import SupportInbox from "@/admin/pages/SupportInbox";
import RejectedPhotos from "@/admin/pages/RejectedPhotos";
import GlassIntros from "@/admin/pages/GlassIntros";
import Eligibility from "@/admin/pages/Eligibility";
import Flags from "@/admin/pages/Flags";
import Settings from "@/admin/pages/Settings";
import Content from "@/admin/pages/Content";
import Prompts from "@/admin/pages/Prompts";
import Dashboard from "@/admin/pages/Dashboard";
import Reports from "@/admin/pages/Reports";
import Appeals from "@/admin/pages/Appeals";
import Interests from "@/admin/pages/Interests";
import Pricing from "@/admin/pages/Pricing";
import Admins from "@/admin/pages/Admins";
import AuditLog from "@/admin/pages/AuditLog";
import Notifications from "@/admin/pages/Notifications";
import DiscoverCheck from "@/admin/pages/DiscoverCheck";
import Storage from "@/admin/pages/Storage";

const page = (el) => <ErrorBoundary>{el}</ErrorBoundary>;

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route index element={page(<Home />)} />
            <Route path="support" element={page(<Support />)} />
            <Route path="faq" element={page(<Faq />)} />
            <Route path="terms" element={page(<LegalPage key="terms" doc="terms" />)} />
            <Route path="privacy" element={page(<LegalPage key="privacy" doc="privacy" />)} />
            <Route path="safety" element={page(<SafetyPage />)} />
            <Route path="guidelines" element={page(<LegalPage key="community_guidelines" doc="community_guidelines" eyebrow="Community" />)} />
            <Route path="how-it-works" element={page(<HowItWorks />)} />
            <Route path="plans" element={page(<Plans />)} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="admin/login" element={page(<AdminLogin />)} />
          <Route path="admin" element={<RequireAdmin><AdminShell /></RequireAdmin>}>
            <Route index element={<AdminHome />} />
            <Route path="dashboard" element={page(<Dashboard />)} />
            <Route path="users" element={page(<Users />)} />
            <Route path="users/:id" element={page(<UserDetail />)} />
            <Route path="discover-check" element={page(<DiscoverCheck />)} />
            <Route path="storage" element={page(<Storage />)} />
            <Route path="reviews" element={page(<Reviews />)} />
            <Route path="reports" element={page(<Reports />)} />
            <Route path="appeals" element={page(<Appeals />)} />
            <Route path="notifications" element={page(<Notifications />)} />
            <Route path="launch" element={page(<Launch />)} />
            <Route path="waitlist" element={<Navigate to="/admin/launch?tab=waitlist" replace />} />
            <Route path="promotions" element={page(<Promotions />)} />
            <Route path="inbox" element={page(<SupportInbox />)} />
            <Route path="photos" element={page(<RejectedPhotos />)} />
            <Route path="glass" element={page(<GlassIntros />)} />
            <Route path="eligibility" element={page(<Eligibility />)} />
            <Route path="flags" element={page(<Flags />)} />
            <Route path="settings" element={page(<Settings />)} />
            <Route path="content" element={page(<Content />)} />
            <Route path="prompts" element={page(<Prompts />)} />
            <Route path="interests" element={page(<Interests />)} />
            <Route path="pricing" element={page(<Pricing />)} />
            <Route path="team" element={page(<Admins />)} />
            <Route path="admins" element={<Navigate to="/admin/team" replace />} />
            <Route path="audit" element={page(<AuditLog />)} />
            <Route path="*" element={<AdminHome />} />
          </Route>
        </Routes>
        <Toaster theme="light" position="top-center" toastOptions={{ className: "rounded-2xl font-[inherit]" }} />
      </AuthProvider>
    </BrowserRouter>
  );
}
